export const preVendasItems = {
  category: "preVendas",
  key: "preVendas",
  name: "Pré-vendas",
};
